import styled, { keyframes } from "styled-components";

const spin = keyframes`
  100% { transform: rotate(1turn); }
`;

const LoaderOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.5); /* Semi-transparent overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure it appears on top */
`;

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  pointer-events: none; /* Allow interaction with underlying content */
`;

const Spinner = styled.div`
  width: ${(props) => props.$size || 40}px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, #ff5f39 94%, #0000)
      top/${(props) => props.$thickness || 8}px
      ${(props) => props.$thickness || 8}px no-repeat,
    conic-gradient(#0000 30%, #ff5f39);
  -webkit-mask: radial-gradient(
    farthest-side,
    #0000 calc(100% - ${(props) => props.$thickness || 8}px),
    #000 0
  );
  animation: ${spin} 1s infinite linear;
`;

const Text = styled.p`
  font-size: 1.25rem;
  font-weight: 600;
`;

// Same spinner as the full-page loader, sized to sit inline inside a form.
export function InlineLoader({ size = 24, thickness = 4 }) {
  return <Spinner $size={size} $thickness={thickness} />;
}

export default function Loader() {
  return (
    <LoaderOverlay>
      <LoaderWrapper>
        <Spinner />
      </LoaderWrapper>
    </LoaderOverlay>
  );
}
